import { Path } from "./Path";
import { GET_MYAPI_NOT_TOKEN } from "./Fetch";

export const Api = {
  _news: Path.urlApi + "news",
  _newsList: Path.urlApi + "news/list",
};

export const CallApiGetNews = (param, handleData) => {
  const url = `${Api._newsList}?type=${param.type}&page=${param.page}&pageSize=${param.pageSize}&searchText=${param.search}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};

export const CallApiGetNewById = (id, handleData) => {
  const url = `${Api._news}/${id}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};
